import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as model from "../../../../models";
import { ControlMessages } from '../../../../ui-helper';

@Component({
	selector: 'ticket-quota-form',
	templateUrl: "./ticket-quota-form.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	styles: [require("./ticket-quota-form.scss")]
})
export class TicketQuotaForm {
	private _ticketQuota
	private showFormErrors: boolean = false

	@Input() set ticketQuota(ticketQuota: model.TicketQuota) {
		if(ticketQuota){
			this._ticketQuota = ticketQuota;
			(<FormControl>this.form.controls["name"]).setValue(ticketQuota.name);
			(<FormControl>this.form.controls["standard"]).setValue(ticketQuota.standard ? ticketQuota.standard : false);
		}
	}

	get ticketQuota() {
		return this._ticketQuota
	}

	@Output() ticketQuotaSaved: EventEmitter<model.TicketQuota> = new EventEmitter<model.TicketQuota>();
	@Output() ticketQuotaSaveUnsuccessful: EventEmitter<void> = new EventEmitter<void>();
	@Output() cancelTicketQuotaAction: EventEmitter<void> = new EventEmitter<void>();

	form: FormGroup

	constructor() {
		this.createTicketQuotaForm()
	}


	public formSaved(newValue) {
		if (this.form.valid) {
			let newTicketQuota = Object.assign({}, this.ticketQuota, {
				name: newValue["name"],
				standard: newValue["standard"]
			})
			this.ticketQuotaSaved.emit(newTicketQuota);
			this.showFormErrors = false;
		} else {
			this.ticketQuotaSaveUnsuccessful.emit(null)
			this.showFormErrors = true
		}


	}

	private createTicketQuotaForm(): FormGroup {
		return this.form = new FormGroup({
			'name': new FormControl('', Validators.required),
			'standard': new FormControl(false)
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/components/event-components/ticket-quota-collection/ticket-quota-form/ticket-qouta-form.component.ts